import React from "react";
import {AdditionalServiceModel} from "../../../pages/shared/models/order/additional-service.model";
import {useAppSelector} from "../../../redux/store";
import {MessageSections} from "../../../pages/components/message/message";
import AdditionalServiceCard, {AdditionalServiceUsage} from "../../../pages/components/additional-service";
import {BarekamIcon, IconVariants} from "../../../pages/components/icon/barekam-icon";
import {AdditionalServiceIcons} from "../../../pages/components/icon/variants";
import {AdditionalServiceWarehouseCardContainer} from "./styled";
import BarekamButton, {OrderButtons} from "../../../pages/components/button";
import {getMessage} from "../../../pages/shared/helper-functions";

export const AdditionalServiceWarehouseCard = ({service, onClick, ordersCount}: AdditionalServiceCardProps) => {
    const {messageCache, languageId} = useAppSelector(state => state.messagesReducer);

    const ServiceIcon = ({service}: {service: string}) => {
        switch (service) {
            case 'check_the_package_contents':
                return <BarekamIcon variant={AdditionalServiceIcons.takeAPhotoFromInside}/>
            case 'additional_packaging':
                return <BarekamIcon variant={AdditionalServiceIcons.repack}/>
            case 'change_receiver':
                return <BarekamIcon variant={AdditionalServiceIcons.takeAPhotoFromInside}/>
            case 'divide_package':
                return <BarekamIcon variant={AdditionalServiceIcons.divide}/>
            case 'on_hold':
                return <BarekamIcon variant={AdditionalServiceIcons.onHold}/>
            default:
                return <>ICO</>
        }
    }

    return (
        <AdditionalServiceWarehouseCardContainer>
            <AdditionalServiceCard usage={AdditionalServiceUsage.WAREHOUSE}
                                   secondaryIcon={<ServiceIcon service={service.name}/>}
                                   count={ordersCount}
                                   selected={false}
                                   slim={true}
                                   mainMessage={getMessage(service.name, MessageSections.ORDERS, messageCache, languageId)}
                                   secondaryMessage={getMessage(service.name + '_info', MessageSections.ORDERS, messageCache, languageId)}
                                   onClick={() => true}/>

            <BarekamButton type={OrderButtons.WAREHOUSE_CARD} onClick={() => void(0)}>
                <BarekamIcon variant={IconVariants.arrow} rotation={-90}/>
            </BarekamButton>
        </AdditionalServiceWarehouseCardContainer>
    );
}

interface AdditionalServiceCardProps {
    service: AdditionalServiceModel,
    onClick: () => void;
    ordersCount?: number
}
